export default __webpack_public_path__ + "static/media/photo3.d4a1b215.jpg";